import { Stack } from "@mui/material";
import React from "react";
import { RightPanel } from "../../components/RightPanel";
import { ManageQuickReplyTemplate } from "./ManageQuickReplyTemplate";
import { IQuickReplyTemplateData } from "../../redux/quickReplyTemplates/quickReplyTemplate.types";

interface IManageQuickReplyTemplateRightPanelProps {
  open: boolean;
  templateData?: IQuickReplyTemplateData;
  onClose: () => void;
  onSaveSuccess: (templateData: IQuickReplyTemplateData) => void;
  isFromRecommendedFromRightpanel?: boolean;
  recommendedTemplateDataFromRightpanel?: IQuickReplyTemplateData;
}

export const ManageQuickReplyTemplateRightPanel: React.FC<
  IManageQuickReplyTemplateRightPanelProps
> = (props) => {
  const {
    open,
    templateData,
    onClose,
    onSaveSuccess,
    recommendedTemplateDataFromRightpanel,
    isFromRecommendedFromRightpanel,
  } = props;

  return (
    <>
      <RightPanel
        heading={
          templateData
            ? "Edit Quick Reply Template"
            : "Create Quick Reply Template"
        }
        open={open}
        width="65%"
        onClose={onClose}
        actionButtons={() => {
          return (
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              spacing={2}
            >
              <Stack direction={"row"} spacing={2}>
                {/* <Button variant="contained" onClick={onClose}>
                  <Close sx={{ fontSize: 18, mr: 0.5 }} />
                  Close
                </Button> */}
                {/* {actions} */}
              </Stack>
            </Stack>
          );
        }}
      >
        <ManageQuickReplyTemplate
          onSaveSuccess={(templateData) => {
            onSaveSuccess(templateData);
          }}
          templateData={templateData}
          fromRightPanel
          isFromRecommendedFromRightpanel={isFromRecommendedFromRightpanel}
          recommendedTemplateDataFromRightpanel={
            recommendedTemplateDataFromRightpanel
          }
        />
      </RightPanel>
    </>
  );
};
